import { Box, FormErrorMessage } from '@chakra-ui/react';
import { Dropdown } from '../../ui';
import { useGetInventoryUnits } from '../../hooks/inventory/useGetInventoryUnits';
import { InventoryUnit } from '../../types/inventory';
import { formatInventoryUnitLabel } from '../../utils/inventoryConstants';

interface UnitSelectFieldProps {
    value: string;
    onChange: (value: InventoryUnit) => void;
    isDisabled?: boolean;
}

const UnitSelectField = ({ value, onChange, isDisabled = false }: UnitSelectFieldProps) => {
    const { data, isLoading, isError } = useGetInventoryUnits();

    const units = data?.units ?? [];
    const selectValue = units.includes(value as InventoryUnit)
        ? (value as InventoryUnit)
        : null;

    return (
        <Box>
            <Dropdown
                size="sm"
                options={units.map((unit) => ({
                    value: unit,
                    label: formatInventoryUnitLabel(unit),
                }))}
                value={selectValue}
                onChange={(unit) => onChange(unit)}
                placeholder={isLoading ? 'Loading units…' : 'Select unit'}
                isDisabled={isDisabled || isLoading || isError || units.length === 0}
            />
            {isError && (
                <FormErrorMessage mt={1}>Could not load units</FormErrorMessage>
            )}
        </Box>
    );
};

export default UnitSelectField;
